<template>
	<div class="relative">
		<button @click="toggleLanguagePicker"
			class="relative mt-1 mr-7 z-10 focus:outline-none"
			aria-label="Language picker">
			<img :src="`/img/flags/${$i18n.locale}.webp`"
				class="h-4 w-6"
				width="24px"
				height="16px"
				:alt="`${$i18n.locale} flag`" />
		</button>

		<div class="absolute z-0 -top-2 w-10 h-9 right-5 bg-white"
			v-if="languagePicker" />

		<ul class="absolute right-5 top-7 py-3 w-20 bg-white text-black shadow-lg"
			v-if="languagePicker">
			<li class="py-1 px-4 flex items-center"
				:class="language === $i18n.locale ? 'opacity-50' : 'hover:bg-black-lightest cursor-pointer'"
				v-for="(language, index) in languages"
				:key="index"
				@click="language !== $i18n.locale ? setLocale(language) : undefined">
				<img :src="`/img/flags/${language}.webp`"
					class="h-4 w-6 mr-1 align-middle"
					:alt="`${language} flag`"
					width="24px"
					height="16px"
					loading="lazy" />
				<span>{{ language }}</span>
			</li>
		</ul>
	</div>

</template>

<script>
export default {
	name: 'LanguageToggle',

	data() {
		return {
			languagePicker: false,

			languages: ['pt', 'en'],
		}
	},

	methods: {
		toggleLanguagePicker() {
			this.languagePicker = !this.languagePicker
		},

		setLocale(locale) {
			this.$store.commit('SET_LOCALE', { i18n: this.$i18n, locale })
			this.toggleLanguagePicker()
		},

		toggleLocale() {
			this.$store.commit('TOGGLE_LOCALE', this.$i18n)
		},
	},
}
</script>